interface ReadingTimeProps {
  words: number;
}

export function ReadingTime({ words }: ReadingTimeProps) {
  const minutes = Math.max(1, Math.ceil(words / 238));

  return (
    <span className="font-body text-xs text-grey">
      {minutes} min read
    </span>
  );
}
